import { LoadingSkeleton } from "shared/components/molecules/LoadingSkeleton";

import { TrendingGroupsLoadingSkeletonContainer } from "./styles";

interface ITrendingGroupsLoadingSkeletonProps {
  contentLength: number;
}

export const TrendingGroupsLoadingSkeleton = ({
  contentLength,
}: ITrendingGroupsLoadingSkeletonProps) => {
  return (
    <TrendingGroupsLoadingSkeletonContainer>
      {Array.from({ length: contentLength }).map((_, index) => (
        <div key={`trending-group-skeleton-${index}`}>
          <div className="index" data-index={index + 1}>
            {index + 1}
          </div>

          <div className="skeleton">
            <LoadingSkeleton.Square width="356px" height="187.31px" />
          </div>
        </div>
      ))}
    </TrendingGroupsLoadingSkeletonContainer>
  );
};
